<template>
  <div class="banner">
    <div class="banner-flow">
      <div class="banner-flow-rotate">
        <div class="banner-flow-column" v-for="(item, index) in bannerList" :key="index">
          <div class="banner-flow-item" v-for="(item2, index2) in item" :key="index2">
            <div class="banner-flow-item-img" :style="`background-image: url(${item2})`"></div>
          </div>
          <div class="banner-flow-item" v-for="(item2, index2) in item" :key="(index2 + 1) * 100">
            <div class="banner-flow-item-img" :style="`background-image: url(${item2})`"></div>
          </div>
        </div>
      </div>
      <img class="banner-flow-mask" src="https://xiaoxxx-new.oss-cn-beijing.aliyuncs.com/test/urlGather/2024022207910f09feac131a284255.png" alt="">
    </div>
    <img class="banner-text" src="https://xiaoxxx-new.oss-cn-beijing.aliyuncs.com/test/urlGather/2024022251e9a9514c3e342e851676.png">
  </div>
</template>

<script>
export default {
  name: 'Banner',
  data() {
    return {
      bannerList: [
      ],
    }
  },
  created() {
    this.api.caseList({
      page: 1,
      pageSize: 20,
      category: 1,
    }).then(res => {
      
      if (res.data.lists.length >= 20) {
        let result = [];
        for (let i = 0; i < res.data.lists.length; i += 4) {
          let arr = []
          res.data.lists.slice(i, i + 4).forEach(element => {
            arr.push(element.cover)
          });
          result.push(arr);
        }
        this.bannerList = result
      }
    })
  }
}
</script>

<style scoped>
.banner {
  width: 100%;
  height: 500px;
  position: relative;
  background: #000;
}
.banner-flow {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
.banner-flow-rotate {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  transform: rotate(-30deg);
}
.banner-flow-column {
  margin: 0 10px 0 0;
  flex-shrink: 0;
}
.banner-flow-column:nth-of-type(1) {
  animation: move 30s linear infinite;
}
.banner-flow-column:nth-of-type(2) {
  animation: move 53s linear infinite ;
}
.banner-flow-column:nth-of-type(3) {
  animation: move 38s linear infinite;
}
.banner-flow-column:nth-of-type(4) {
  animation: move 48s linear infinite;
}
.banner-flow-column:nth-of-type(5) {
  animation: move 26s linear infinite;
}
.banner-flow-item {
  width: 360px;
  height: 710px;
  box-sizing: border-box;
  padding: 20px;
  background: url('https://xiaoxxx-new.oss-cn-beijing.aliyuncs.com/test/urlGather/20240221e410bac21c06af11521858.png') center / 100% 100% no-repeat;
  /* transform: rotate(-30deg); */
  margin-top: 20px;
}
.banner-flow-item-img {
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  mask: url('https://xiaoxxx-new.oss-cn-beijing.aliyuncs.com/test/urlGather/2024022167dd95c144d72868211953.png') center / 100% 100% no-repeat;
}
@keyframes move {
  0% {
    transform: translateY(-20%);
  }
  100% {
    transform: translateY(-70%);
  }
}
.banner-flow-mask {
  width: 100%;
  height: 100%;
  opacity: 0.8;
  position: absolute;
  left: 0;
  top: 0;
}
.banner-text {
  width: 960px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  animation: show 2s 0.3s forwards;
}
@keyframes show {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@media screen and (max-width: 750px) {
  .banner {
    height: 50vw;
  }
  .banner-flow-item {
    width: 120px;
    height: 236px;
    padding: 10px;
    margin-top: 10px;
  }
  .banner-text {
    content: url('https://image.xiaoxxx.cn/test/urlGather/20240520a1ccf5a72f5b642f303679.png');
    width: 85%;
  }
}
</style>